import type { Permission, RoleKey } from './permissions';

export const WORKSPACE_HEADER = 'x-workspace-id';
export const DEFAULT_WORKSPACE_ID = 'workspace_meraki';

export type WorkspaceKind = 'restaurant' | 'rnd_kitchen' | 'test_kitchen';
export type WorkspaceStatus = 'active' | 'archived';
export type WorkspaceMemberStatus = 'active' | 'disabled';
export type CulinaryLanguage = 'zh-Hans' | 'en' | 'fr' | 'und';
export type WorkspaceUnitSystem = 'metric';

export interface WorkspaceSummary {
  id: string;
  name: string;
  kind: WorkspaceKind;
  identityMark: string;
  timezone: string;
  status: WorkspaceStatus;
  membershipStatus: WorkspaceMemberStatus;
  roles: RoleKey[];
  permissions: Permission[];
  memberCount: number;
}

export interface WorkspaceSettings {
  id: string;
  name: string;
  kind: WorkspaceKind;
  identityMark: string;
  accentHint: string;
  timezone: string;
  primaryCulinaryLanguage: CulinaryLanguage;
  preferredLocalizationLanguages: CulinaryLanguage[];
  defaultUnitSystem: WorkspaceUnitSystem;
  status: WorkspaceStatus;
  revision: number;
}

export interface CreateWorkspaceInput {
  name: string;
  kind?: WorkspaceKind;
  primaryCulinaryLanguage?: CulinaryLanguage;
  requestKey?: string;
}

export interface UpdateWorkspaceSettingsInput {
  name: string;
  kind: WorkspaceKind;
  identityMark: string;
  timezone: string;
  primaryCulinaryLanguage: CulinaryLanguage;
  preferredLocalizationLanguages: CulinaryLanguage[];
  defaultUnitSystem: WorkspaceUnitSystem;
  revision: number;
}

export interface WorkspaceLifecycleInput {
  currentPassword: string;
  revision: number;
}
